
window.App ?= {}
window.App.Models ?= {}
window.App.Models.Submission ?= {}
window.App.Models.Submission.Field ?= {}
window.App.Models.Submission.Field.Helpers ?= {}

window.App.Models.Submission.Field.Helpers.Boolean = App.Models.Submission.Field.Helpers.Dropdown
